import pt from './languages/pt';
import en from './languages/en';

interface TranslationsInterface {
  'print-title': string;
  'map-title': string;
  format: string;
  'page-size': string;
  orientation: string;
  'include-legend': string;
  point: string;
  polyline: string;
  'freehand-polyline': string;
  arrow: string;
  triangle: string;
  rectangle: string;
  circle: string;
  ellipse: string;
  'freehand-polygon': string;
  text: string;
  'banner-cookie': string;
  'cookie-policy': string;
  'cookie-accept': string;
  'cookie-reject': string;
  'splash-window-1': string;
  'splash-window-2': string;
  help: string;
  close: string;
  themes: string;
  'turnoff-layers': string;
  dock: string;
  undock: string;
  back: string;
  'go-to': string;
  'no-data': string;
  compass: string;
  'my-location': string;
  'help-menu': string;
  'reset-map-orientation': string;

  // Coberturas disponíveis
  'fixed-network': string;
  'mobile-network': string;
  satellite: string;
  operator: string;
  technology: string;
  'download-speed': string;
  'upload-speed': string;
  'coverage-download': string;
  expand: string;
  collapse: string;
  'fixa-msg': string;
  'movel-msg': string;
  'satelite-msg': string;
  'error-load-fixed-network': string;
  'error-load-mobile-network': string;
  'error-load-satellite': string;

  // Aba identificar
  results: string;
  buffer: string;
  symbology: string;
  zoom: string;
  'select-all': string;
  'clear-id': string;
  'distance-meters': string;
  color: string;
  transparency: string;
  cancel: string;
  apply: string;
  points: string;
  lines: string;
  polygons: string;
  polygon: string;
  'access-here': string;
  size: string;
  thickness: string;
  outline: string;
  fill: string;

  // Aba pesquisar (há campos repetidos)
  search: string;
  layer: string;
  field: string;
  values: string;
  'search-placeholder': string;
  'select-values-placeholder': string;
  'fixed-distance': string;
  'interactive-distance': string;
  line: string;
  distance: string;
  meters: string;
  'save-image': string;

  // Widget Modal labels
  'load-data': string;
  'add-layer': string;
  'heat-map': string;
  'cluster-map': string;
  add: string;
  clear: string;
  'coverage-quota': string;
  tools: string;
  'property-quota': string;
  'search-by-drawing': string;
  'advanced-search': string;
  measurement: string;
  'register-element': string;
  'convert-coordinate': string;
  'map-management': string;
  'print-map': string;
  print: string;
  occurrence: string;
  'register-event': string;
  'next-view': string;
  edit: string;
  announcements: string;
  'initial-view': string;
  navigation: string;
  sketch: string;
  'previous-view': string;
  path: string;
  'clear-section': string;
  geoprocessing: string;
  'access-and-services': string;
  'share-map': string;
  share: string;
  move: string;
  'map-name': string;
  complaints: string;
  notes: string;
  indicators: string;
  type: string;
  'identify-results': string;
  'available-coverage': string;

  // Widget Modal Log labels
  identify: string;

  // Widget Map labels
  scales: string;
  coordinates: string;
  overview: string;
  'coordinates-list': string;
  display: string;
  'projected-coordinates-list': string;
  project: string;
  get: string;
  'enter-coordinates': string;

  // Tool Map labels
  'current-location': string;
  'street-view': string;
  'zoom-by-window': string;
  fullscreen: string;
  rotation: string;
  'share-link': string;

  // Tool Map Action labels
  'zoom-in': string;
  'zoom-out': string;
  'initial-viewpoint': string;
  'previous-viewpoint': string;
  'next-viewpoint': string;
  screenshot: string;

  //Medir
  measure: string;
  'square-meters': string;
  'square-kilometers': string;
  kilometers: string;
  radius: string;

  //Geoprocessamento
  concentration: string;
  aggregation: string;

  //Adicionar camada
  url: string;
  file: string;

  // TOC
  'base-maps': string;
  'spectrum-planning-and-management': string;
  'spectrum-monitoring-and-supervision': string;
  coverage: string;
  'postal-services': string;
  'statistics-and-market-analysis': string;
  infrastructures: string;
  'general-themes': string;
  'external-layers': string;
  'sketch-type': string;
  'point-type': string;
  'point-color': string;
  'point-size': string;
  'outline-color': string;
  'outline-thickness': string;
  'line-type': string;
  'fill-color': string;
  'text-size': string;
  'text-color': string;
  draw: string;
  'delete-all': string;
  delete: string;
  square: string;
  diamond: string;
  cross: string;
  solid: string;
  dash: string;
  dot: string;
  'dash-dot': string;
  'long-dash-dot-dot': string;
  'line-color': string;
  'drop-or-browse': string;
  'supported-file-formats': string;

  // Mensagens
  'failed-load-location': string;
  'select-location': string;
  warning: string;
  'select-location-or-enter-address': string;
  'failed-load-data': string;
  'failed-load-page': string;
  'not-authenticated': string;
  'failed-generate-link': string;
  'failed-load-WKID-list': string;
  'failed-load-favorite-map': string;
  'map-not-found': string;
  'failed-load-map': string;
  'failed-export-image': string;
  'failed-upload-file': string;
  'layer-added-successfully': string;
  'failed-load-layer': string;
  'no-route-found': string;
  'unable-calculate-routes': string;
  'invalid-coordinates': string;
  'failed-project-coordinates': string;
  'fill-required-fields-correctly': string;
  'event-saved-successfully': string;
  'failed-save-event': string;
  'upload-completed-successfully': string;
  'no-records-found': string;
  'failed-fetch-data': string;
  'export-large-items': string;
  'failed-export-data': string;
  'failed-load-attachments': string;
  'unable-retrieve-current-location': string;
  'process-created-successfully': string;
  'failed-create-process': string;
  'only-zip-allowed': string;
  'uploaded-successfully': string;
  'failed-read-file': string;
  'map-loaded-successfully': string;
  'map-shared-successfully': string;
  'failed-share-map': string;
  'map-imported-successfully': string;
  'failed-import-map': string;
  map: string;
  'marked-favorite-successfully': string;
  'failed-to': string;
  'mark-map-as-favorite': string;
  'map-deleted-successfully': string;
  'failed-delete-record': string;
  'map-saved-successfully': string;
  'failed-save-data': string;
  'failed-download-attachment': string;
  'failed-load-incident-statuses': string;
  'failed-load-incident-types': string;
  'incident-status-updated-successfully': string;
  'failed-update-incident-status': string;
  'select-area': string;
  'incident-saved-successfully': string;
  'failed-save-incident': string;
  'failed-load-entities': string;
  'failed-fetch-incident-data': string;
  'failed-load-results': string;
  'printing-failed': string;
  'data-saved-successfully': string;
  'no-features-found': string;
  'filter-deleted-successfully': string;
  'failed-delete-history-filter': string;
  'failed-load-history': string;
  'failed-load-documents': string;
  'search-saved-successfully': string;
  'failed-save-search': string;
  'link-copied-clipboard': string;
  'map-link-generated-successfully': string;
  'unable-access-data': string;
  'you-are-not-authenticated': string;
  sucess: string;
  error: string;
  alert: string;
  'light-gray-canvas': string;
  'dark-gray-canvas': string;
  'imagery-hybrid': string;
  'national-geographic-map': string;
  'navigation-map': string;
  oceans: string;
  streets: string;
  'terrain-with-labels': string;
  topographic: string;
  example: string;
  copy: string;
  includeNull: string;
}

const availableLanguages = {
  pt: 'pt',
  en: 'en',
};

const defaultLanguage = {
  code: availableLanguages.pt,
  value: pt,
};

export { TranslationsInterface, pt, en, defaultLanguage, availableLanguages };
